function App() {
  return (
    <div>
      <h1>Hello!</h1>
    </div>
  );
}

export default App;
